module.exports = __webpack_public_path__ + "static/media/homer.82350cd6.jpg";